import { TREADWELL_AI_LOADING_MESSAGES } from '../constants/treadwell-product-explanation-constants';

export function pickRandomLoadingMessage(arrIdx, lastMessage) {
  const currentArr =
    TREADWELL_AI_LOADING_MESSAGES[arrIdx] ??
    TREADWELL_AI_LOADING_MESSAGES[TREADWELL_AI_LOADING_MESSAGES.length - 1];

  let currentMessage =
    currentArr[Math.floor(Math.random() * currentArr.length)];

  if (currentArr.length > 1 && currentMessage === lastMessage) {
    const alternativeMessages = currentArr.filter(
      message => message !== lastMessage
    );
    currentMessage =
      alternativeMessages[
        Math.floor(Math.random() * alternativeMessages.length)
      ];
  }

  return currentMessage;
}
